import React from 'react'

//component
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable'
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector';

//hooks
import UseUserWorkspacesTab from './UserWorkspacesTab.hooks';

//styling
import "../../../../../css/orgSettings/users/workspaces.scss"



const UserWorkspacesTab = () => {  
    const {noDataMessage, tableContent, isLoading, setPage, paginationSettings, showSimpleTable} = UseUserWorkspacesTab();

    return(
        <div className="workspaces-screen" data-testid="user-workspaces-tab">
            {showSimpleTable && <SimpleTable isLoading={isLoading} simpleTableContent={tableContent} noDataMessage={noDataMessage} isInfiniteScroll={false}/>}
            
            {paginationSettings?.hasPagination && <SimplePageSelector currentPage={paginationSettings.currentPage} totalPages={paginationSettings.totalPages} setPage={setPage} />}
        </div>
    )
}

export default UserWorkspacesTab